import React from 'react';
import styles from './JobseekerProfileEmployerViewBody.module.css';
import { useTranslation } from 'react-i18next';

function AboutMe({ jobseeker, ref }) {
    const { t } = useTranslation();
    const stripHTML = (input) => {
        const allowedTags = ['b', 'i', 'strong', 'em', 'p', 'br', 'ul', 'ol', 'li'];
        const doc = new DOMParser().parseFromString(input, 'text/html');
        const elements = doc.body.querySelectorAll('*');

        elements.forEach(element => {
            if (!allowedTags.includes(element.nodeName.toLowerCase())) {
                element.replaceWith(...element.childNodes);
            }
        });

        return doc.body.innerHTML;
    };

    return (
        <div ref={ref} id='aboutMe' className={`${styles.aboutMe} aboutOurCompany`} style={{
            width: '100%', minHeight: "0px", overflow: "hidden",
        }}>
            <img className={styles.aboutMeBg} src={require('../../../../assets/images/AboutCompanyBg.png')} />
            <h2 className={styles.heading}>{t(`aboutMe.about_our_company`)}</h2>
            <div
                className={styles.description}
                dangerouslySetInnerHTML={{
                    __html: jobseeker.employer_status == "business" ? jobseeker?.company_description ? stripHTML(jobseeker?.company_description) : '' : jobseeker?.description && stripHTML(jobseeker?.description)
                }}
            ></div>
        </div>
    );
}

export default AboutMe;
